module.exports = __webpack_public_path__ + "static/7-04014d14645af77bb4429a516372099f.png";